<template>
  <div ref="tags">
    <div class="tags-body" @click="selectTag" @click.middle="closeSelectedTag" :style="{width: tagsBodyWidth + 'px'}">
      <div class="tags-item" :class="{active: selectedFile.key === tag.key, unsaved: tag.unsaved}"
        v-for="(tag,index) in visitedFiles" :key="`tag_${tag.key}`" :data-index="index">
        {{ tag.key.replace(/^.*\//, '') }}
        <qc-icon type="remove" class="ml-5" @click="closeSelectedTag"></qc-icon>
      </div>
    </div>
    <div class="tags-menu" ref="tagsMenu">
      <div class="cos-icon--24 save mr-10"
        v-if="showIcon.save" @click="saveSelectedTag">
      </div>
      <div class="cos-icon--24 browser mr-10" v-if="showIcon.browser"
        @click="openFileByBrowser"></div>
      <div class="cos-icon--24 more-operate mr-10" @click="openDropmenu" v-click-outside="onClickOutside"></div>
    </div>

    <editor-dropmenu :show.sync="dropmenuShow" :position="dropmenuPosition" :options="dropmenuOptions" :action="action"
      @on-action="onDropmenuAction" />
  </div>
</template>

<script>

import $ from 'jquery';
import cosPure from '@/scripts/helper/cos/cosPure';
import cos from '@/scripts/helper/cos/index';
import eventProxy from '@/scripts/tools/eventProxy';

import editorDropmenu from '@/components/common/editorDropmenu.vue';

export default {
  components: {
    editorDropmenu,
  },
  props: {
    visitedFiles: Array,
    selectedFile: Object,
    bucketInfo: Object,
    domainSetting: Object,
  },
  data() {
    return {
      dropmenuShow: false,
      dropmenuPosition: {},
      dropmenuOptions: {},
      dropmenuAction: '',
      action: '',
      tagsBodyWidth: 0,
    };
  },
  computed: {
    showIcon() {
      const notError = this.selectedFile && this.selectedFile.key && !this.selectedFile.error;
      const show = {
        save: notError && this.selectedFile.unsaved,
        browser: notError,
      };
      return show;
    },
  },
  watch: {
    showIcon(val, old) {
      if (val.browser !== old.browser) {
        this.$nextTick(() => {
          this.renderTagBodyWidth();
        });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.renderTagBodyWidth();
    });
    eventProxy.on('winResize', this.renderTagBodyWidth);
  },
  methods: {
    selectTag(e) {
      const { dataset } = e.target;
      if (dataset.index) {
        const { index } = dataset;
        this.$emit('select-tag', index);
        setTimeout(() => {
          this.renderTagBodyWidth();
        }, 100);
      }
    },
    closeSelectedTag(e) {
      let { target } = e;
      if (target.dataset && !target.dataset.index) {
        target = target.parentNode;
      }
      const { dataset } = target;
      if (dataset.index) {
        const { index } = dataset;
        this.$emit('close-tag', index);
      }
    },
    getCurrentFileIndex() {
      let index = 0;
      let file = this.visitedFiles[index];
      const len = this.visitedFiles.length;
      while (index < len && file.key !== this.selectedFile.key) {
        file = this.visitedFiles[++index];
      }
      return index;
    },
    saveSelectedTag() {
      const currIndex = this.getCurrentFileIndex();
      this.$emit('save-tag', currIndex);
    },
    openDropmenu(e) {
      const { target } = e;
      this.dropmenuOptions = {
        allowSaveAs:
          Object.keys(this.selectedFile).length > 0 && !this.selectedFile.error,
      };

      const targetOffset = $(target).offset();
      const [targetX, targetY] = [targetOffset.left, targetOffset.top];
      const [targetW, targetH] = [target.clientWidth, target.clientHeight];

      const dropmenuW = this.$store.localeLanguage === 'zh' ? 100 : 176.5;
      let left = targetX + targetW - dropmenuW;
      if (left < 0) {
        left = targetX + targetW - 16;
      }

      // 下拉菜单的展开方向
      const top = targetY + targetH + 5;

      this.dropmenuPosition = { left, top };
      this.dropmenuShow = true;
      this.action = 'dropmenu';
    },
    onDropmenuAction(action) {
      const index = this.getCurrentFileIndex();
      const val = { index, action };
      this.$emit('on-dropmenu', val);
    },
    async openFileByBrowser() {
      const { domainSetting } = this;
      let url = '';
      let baseUrl = '';
      if (domainSetting && domainSetting.bucket === this.bucketInfo.Bucket) {
        const { domain, type } = domainSetting;

        cosPure.options.Domain = domain;
        cosPure.options.Protocol = cos.options.Protocol;
        baseUrl = cosPure.getObjectUrl({
          ...this.bucketInfo,
          Key: this.selectedFile.key,
        });

        url = baseUrl;
        if (type === 'sign') {
          url = await cos.getDownloadUrl(url, false, 1800);
        }
        window.open(url);
        return;
      }
      const { Website, ACL } = this.bucketInfo;
      if (Website) {
        cosPure.options.Domain = Website;
        cosPure.options.Protocol = cos.options.Protocol;
        baseUrl = cosPure.getObjectUrl({
          ...this.bucketInfo,
          Key: this.selectedFile.key,
        });
      } else {
        baseUrl = cos.getObjectUrl({
          ...this.bucketInfo,
          Key: this.selectedFile.key,
        });
      }

      url = baseUrl;
      if (!ACL.includes('public')) {
        url = await cos.getDownloadUrl(baseUrl, false, 1800);
      }
      window.open(url);
    },
    onClickOutside() {
      this.action = '';
    },
    renderTagBodyWidth() {
      if (!this.$refs.tags || !this.$refs.tagsMenu) return;
      const { clientWidth } = this.$refs.tags;
      const tagsManuWidth = this.$refs.tagsMenu.clientWidth;
      this.tagsBodyWidth = clientWidth - tagsManuWidth;
    },
  },
};
</script>

<style scoped lang="scss">
.unsaved::before {
  content: '';
  position: absolute;
  right: 24px;
  top: 16px;
  box-sizing: border-box;
  width: 6px;
  height: 6px;
  background: #939495;
  border-radius: 50%;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.tags-body {
  position: relative;
  z-index: 10;
  overflow: hidden; /* 防止溢出 */
}
.tags-menu {
  position: relative;
  z-index: 20;
}
.cos-icon--24 {
  position: relative;
  z-index: 30;
}
</style>
